import { whySection } from "../content/homepage"
import useIsMobile from "../hooks/useIsMobile"

export default function WhySection() {
    const isMobile = useIsMobile()

    return (
        <section style={{ maxWidth: 1280, margin: "0 auto", padding: isMobile ? "4px 20px 64px" : "8px 24px 100px" }}>
            <h2 style={{ fontSize: isMobile ? 32 : 56, marginBottom: 12, letterSpacing: "-0.04em" }}>
                {whySection.heading}
            </h2>
            <p style={{ fontSize: isMobile ? 17 : 20, color: "#6B7280", marginBottom: isMobile ? 40 : 64 }}>
                {whySection.subheading}
            </p>

            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: isMobile ? 28 : 36 }}>
                {whySection.features.map((feature) => (
                    <div key={feature.title} style={{ borderTop: "3px solid #2563EB", paddingTop: 24 }}>
                        <h3 style={{ fontSize: isMobile ? 18 : 22, fontWeight: 700, margin: "0 0 10px" }}>
                            {feature.title}
                        </h3>
                        <p style={{ color: "#6B7280", fontSize: isMobile ? 15 : 17, lineHeight: 1.75, margin: 0 }}>
                            {feature.description}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    )
}
